import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Toast } from "vant";
import {localStorageGetItem} from '@/utils/auth'

// 请求超时
const timeout = 60000;
axios.defaults.timeout = timeout;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data";
axios.defaults.headers.post["TENANT-ID"] = localStorageGetItem('TENANT-ID') || "0"; 
// axios.defaults.headers.post["TENANT-ID"] = "73"; 
  
// 请求拦截
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject({ status: 633, message: error });
  }
);
// 返回拦截
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error && error.stack.indexOf("timeout") > -1) {
      Toast.fail("请求超时");
      return {
        code: 633,
        message: "请求超时",
        success: false
      };
    } else if (error.response.data.code === "SYSTEM_LOGIN_ERROR") {
      store.commit("SET_USERINFO", {});
      // const role = store.state.role;
      Toast.fail({
        message: "登录信息已过期，请重新登录后再试",
        duration: 2000,
        onClose: () => {
          router.push("/login");
        }
      });
    } else {
      return Object.assign(error.response, { success: false });
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params, headers = null) {
  const token =
    store.state.userInfo && store.state.userInfo.token
      ? store.state.userInfo.token
      : "";
  // const _params = Object.assign(params ? params : {}, { token });
  return axios({
    method: "get",
    url,
    params: params,
    timeout: timeout,
    headers: headers ? Object.assign(headers, { token }) : { token }
  })
    .then(checkStatus)
    .then(checkCode);
}
export function curlget(url, params, headers = null) {
  return axios({
    method: "get",
    url,
    params: params,
    timeout: timeout,
    headers: headers
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, data, params = null, headers = null) {
  const token =
    store.state.userInfo && store.state.userInfo.token ? store.state.userInfo.token : "";
  // const _data = Object.assign(data ? data : {}, { token });
  return axios({
    method: "post",
    url,
    params: params ? params : {},
    data: data,
    timeout: timeout,
    headers: headers ? Object.assign(headers, { token }) : { token }
  }).then(checkStatus).then(checkCode);
}
// 上传文件
export function post2(url, data, params = null, headers = null) {
  const token =
    store.state.userInfo && store.state.userInfo.token
      ? store.state.userInfo.token
      : "";
  // const _data = Object.assign(data ? data : {}, { token });
  return axios({
    method: "post",
    url,
    params: params ? params : {},
    data: data,
    timeout: 3000000,
    headers: headers ? Object.assign(headers, { token }) : { token }
  }).then(checkStatus).then(checkCode);
}

function checkStatus(response) {
  // 正常状态返回数据
  if (response.status === 200 || response.status === 304) {
    return response.data.data;
  }
  // 异常状态返回404,500错误等
  let message = "";
  switch (response.status) {
    case 400:
      // 错误请求
      message = "错误请求";
      break;
    case 401:
      // 未授权
      message = "服务器未授权的请求";
      break;
    case 403:
      // 拒绝访问
      message = "服务器拒绝访问";
      break;
    case 404:
      // 未找到该资源
      message = "无服务器请求";
      break;
    case 405:
      // 请求方法未允许
      message = "服务器未允许的请求方法";
      break;
    case 408:
      // 请求超时
      message = "服务器繁忙";
      break;
    case 500:
      // 服务器错误
      if (response.data.message) {
        message = `${response.data.message}`;
      } else {
        message = "服务器错误";
      }
      break;
    case 501:
      // 网络未实现
      message = "无网络";
      break;
    case 502:
      // 网络错误
      message = "网络错误";
      break;
    case 503:
      // 服务不可用
      message = "服务不可用";
      break;
    case 504:
      // 网络超时
      message = "网络信号弱";
      break;
    case 505:
      // http版本不支持该请求
      message = "不支持的请求";
      break;
    case 633:
      message = response.message;
      break;
    default:
      message = `${response.message}`;
  }
  Toast.fail("Error:" + message);
  return {
    code: response.status || "fail",
    message: message,
    data: null,
    success: false
  };
}
function checkCode(response) {
  if (response.code !== 20000 && response.code !== 40127) {
    // 后端约定 code === 20000 为正常请求
    Toast.fail(response.data || response.message);
    return Object.assign(response, { success: false });
  } else {
    return Object.assign(response, { success: true });
  }
}
